<template>
	<InertiaLink 
		class="w-full flex items-center justify-center border border-transparent shadow-sm font-medium text-white bg-primary hover:shadow-lg transition-all"
		:class="{
			'px-4 py-2 rounded-md text-base': variant === 'default',
			'px-4 py-2 text-base md:text-lg': variant === 'medium',
			'px-4 py-3 text-base md:text-lg': variant === 'large',
		}"
	>
        <slot></slot>
    </InertiaLink>
</template>

<script>
	export default {
		props: {
			variant: {
				type: String,
				default: 'default',
			}
		}
	}
</script>